import {dateFromServer} from "@/functions/dates.ts";
import {GetWorkspaceOrganization, OrganizationId, WorkspaceId} from "@/sdk.ts";

export class Organization {
  readonly pid: OrganizationId;
  readonly created_at: Date;
  readonly workspace_id: WorkspaceId;
  organization_name: string;
  updated_at: Date | null;

  constructor(props: GetWorkspaceOrganization.Result) {
    this.pid = props.pid;
    this.workspace_id = props.workspace_id;
    this.organization_name = props.organization_name;
    this.created_at = dateFromServer(props.created_at);
    this.updated_at = props.updated_at ? dateFromServer(props.updated_at) : null;
  }
}